import * as types from "../../constants";

export default function reducer(state = {}, actions) {
  switch (actions.type) {
    case types.COUNTRIES_SELECT_PENDING:
      return {
        ...state,
        pending: true,
        data: [],
      };
    case types.COUNTRIES_SELECT_IN_SUCCESS:
      return {
        ...state,
        pending: false,
        data: actions.payload,
      };
    case types.COUNTRIES_SELECT_IN_FAILURE:
      return {
        ...state,
        pending: false,
        error: actions.error,
        data: [],
      };
    default:
      return state;
  }
}
